let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j8OKz")).then(() => parcelRequire('gt5E9'));